import styled, { css } from "styled-components"

const colors = css`
  --icon-btn-outline: solid;
  &.variant--default {
    &.color--default {
      --icon-btn-color-text: var(--color-neutral-200);
      --icon-btn-color-text-dark: var(--color-neutral-300);
      --icon-btn-color-bg-dark: var(--color-neutral-50);
    }
    &.color--primary {
      --icon-btn-color-text: var(--color-primary);
      --icon-btn-color-bg-dark: var(--color-neutral-10);
    }
    &.color--danger {
      --icon-btn-color-text: var(--color-danger);
      --icon-btn-color-bg-dark: var(--color-neutral-10);
    }
    &.color--warning {
      --icon-btn-color-text: var(--color-warning-dark);
      --icon-btn-color-bg-dark: var(--color-warning-75);
    }
    &.color--success {
      --icon-btn-color-text: var(--color-success-dark);
      --icon-btn-color-bg-dark: var(--color-success-light);
    }
  }
  &.variant--outlined {
    --icon-btn-color-bg-dark: var(--color-neutral-10);
    &.color--default {
      --icon-btn-color-text: var(--color-neutral-200);
      --icon-btn-color-text-dark: var(--color-neutral-300);
      --icon-btn-color-border: var(--color-neutral-75);
    }
    &.color--primary {
      --icon-btn-color-text: var(--color-primary);
      --icon-btn-color-border: var(--color-primary);
    }
    &.color--danger {
      --icon-btn-color-text: var(--color-danger);
      --icon-btn-color-border: var(--color-danger);
      --icon-btn-color-bg-dark: transparent;
    }
    &.color--warning {
      --icon-btn-color-text: var(--color-warning-dark);
      --icon-btn-color-bg-dark: var(--color-warning-75);
      --icon-btn-color-border: var(--color-warning-light);
    }
    &.color--success {
      --icon-btn-color-text: var(--color-success-dark);
      --icon-btn-color-bg-dark: var(--color-success-light);
      --icon-btn-color-border: var(--color-success);
    }
  }
  &.variant--dashed {
    --icon-btn-outline: dashed;
    --icon-btn-color-bg-dark: var(--color-neutral-10);
    &.color--default {
      --icon-btn-color-text: var(--color-neutral-200);
      --icon-btn-color-text-dark: var(--color-neutral-300);
      --icon-btn-color-border: var(--color-neutral-75);
    }
    &.color--primary {
      --icon-btn-color-text: var(--color-primary);
      --icon-btn-color-border: var(--color-primary-light);
    }
    &.color--danger {
      --icon-btn-color-text: var(--color-danger);
      --icon-btn-color-border: var(--color-danger);
      --icon-btn-color-bg-dark: var(--color-danger-light);
    }
    &.color--warning {
      --icon-btn-color-text: var(--color-warning-dark);
      --icon-btn-color-bg-dark: var(--color-warning-75);
      --icon-btn-color-border: var(--color-warning-light);
    }
    &.color--success {
      --icon-btn-color-text: var(--color-success-dark);
      --icon-btn-color-bg-dark: var(--color-success-light);
      --icon-btn-color-border: var(--color-success);
    }
  }
  &.variant--contained {
    &.color--default {
      --icon-btn-color-text: var(--color-neutral-300);
      --icon-btn-color-bg: var(--color-neutral-50);
    }
    &.color--primary {
      --icon-btn-color-text: var(--color-layout-main);
      --icon-btn-color-bg: var(--color-primary);
    }
    &.color--danger {
      --icon-btn-color-text: var(--color-layout-main);
      --icon-btn-color-bg: var(--color-danger);
    }
    &.color--warning {
      --icon-btn-color-text: var(--color-layout-main);
      --icon-btn-color-bg: var(--color-warning);
    }
    &.color--success {
      --icon-btn-color-text: var(--color-layout-main);
      --icon-btn-color-bg: var(--color-success);
    }
  }
`
export const BaseIconButton = styled.button`
  ${colors}

  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  outline: none;
  cursor: pointer;
  border-radius: 100%;
  color: var(--icon-btn-color-text);
  background-color: transparent;
  border: none;
  transition: background-color var(--duration-300) ease-out;
  background-color: var(--icon-btn-color-bg, transparent);
  border: 2px var(--icon-btn-color-border, var(--icon-btn-color-bg))
    var(--icon-btn-outline);

  :disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
  :hover {
    color: var(--icon-btn-color-text-dark, var(--icon-btn-color-text));
    background-color: var(--icon-btn-color-bg-dark, var(--icon-btn-color-bg));
    border-color: var(
      --icon-btn-color-border,
      var(--icon-btn-color-bg-dark, var(--icon-btn-color-bg))
    );
  }

  &.size--xsmall {
    width: var(--size-6);
    height: var(--size-6);
    min-width: var(--size-6);
    min-height: var(--size-6);
  }

  &.size--small {
    width: var(--size-7);
    height: var(--size-7);
    min-width: var(--size-7);
    min-height: var(--size-7);
  }
  &.size--default {
    width: var(--size-9);
    height: var(--size-9);
    min-width: var(--size-9);
    min-height: var(--size-9);
  }
  &.size--large {
    width: var(--size-12);
    height: var(--size-12);
    min-width: var(--size-12);
    min-height: var(--size-12);
  }
  &.size--xlarge {
    width: var(--size-14);
    height: var(--size-14);
    min-width: var(--size-14);
    min-height: var(--size-14);
  }
`
